import { supabase } from '../supabase/client';

interface OperationLog {
  id: string;
  adminId: string;
  adminName: string;
  adminRole: string;
  action: string;
  targetName: string;
  targetPhone: string;
  timestamp: string;
}

export async function addLog(
  adminId: string,
  adminName: string,
  adminRole: string,
  action: string,
  targetName: string,
  targetPhone: string
): Promise<boolean> {
  try {
    const { error } = await supabase.from('admin_operation_logs').insert({
      admin_id: adminId,
      admin_name: adminName,
      admin_role: adminRole,
      operation_type: action,
      target_user_name: targetName,
      target_user_id: targetPhone,
      details: { targetPhone }
    });

    if (error) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}
